import { render, staticRenderFns } from "./Chem115_LabSkills_TaAssessment.vue?vue&type=template&id=b7780cea&scoped=true&"
import script from "./Chem115_LabSkills_TaAssessment.vue?vue&type=script&lang=ts&"
export * from "./Chem115_LabSkills_TaAssessment.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7780cea",
  null
  
)

export default component.exports